// import React, { useEffect, useState } from "react";
// import img from "../../Images/Rectangle 42213.png";
// import img2 from "../../Images/Rectangle 42213 (1).png";
// import img3 from "../../Images/Rectangle 42213 (2).png";
// import img4 from "../../Images/Rectangle 42213 (3).png";
// import img5 from "../../Images/Rectangle 42213 (4).png";
// import logo from "../../Images/Group 1171276875.png";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import HomeService from "../../Services/HomeService";
// import { toast } from "react-toastify";
// const UpcomingProjects = () => {
//   const [reels, setReels] = useState([]);
//   const [isActiveReelsPlayer, setIsActiveReelsPlayer] = useState(false);

//   const fetchReels = async () => {
//     try {
//       const res = await HomeService.getReels();
//       //   console.log("get Reels", res);
//       if (res?.status) {
//         setReels(res?.data);
//       } else {
//         toast.error(res?.message);
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error(error?.message);
//     }
//   };

//   useEffect(() => {
//     fetchReels();
//   }, []);

//   const settings = {
//     className: "center",
//     centerMode: true,
//     infinite: true,
//     centerPadding: "340px",
//     slidesToShow: 3,
//     speed: 500,
//     responsive: [
//       {
//         breakpoint: 1399,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           centerPadding: "250px",
//         },
//       },
//       {
//         breakpoint: 1199,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           centerPadding: "150px",
//         },
//       },
//       {
//         breakpoint: 999,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           centerPadding: "100px",
//         },
//       },
//       {
//         breakpoint: 799,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           centerPadding: "0px",
//         },
//       },
//       {
//         breakpoint: 699,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           centerPadding: "0px",
//           centerMode: false,
//         },
//       },
//       {
//         breakpoint: 499,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           centerPadding: "0px",
//           centerMode: false,
//         },
//       },
//     ],
//   };
//   return (
//     <>
//       <div className="upcoming_project_wrapper">
//         <div className="">
//           <h1 className="upcoming_projects_head">Our Upcoming Projects</h1>
//           <Slider {...settings}>
//             {reels.map((e, i) => (
//               <div className="projects_div_wrapper156">
//                 <img className="project_img456" src={e?.thumbnail} />
//                 <img src={logo} className="circle_img_wrapper" />
//                 <div className="project_details_div_wrapper5666">
//                   <p>Kolkata</p>
//                   <small>Real Estate</small>
//                 </div>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UpcomingProjects;

import React, { useEffect, useState } from "react";
import img from "../../Images/Rectangle 42213.png";
import img2 from "../../Images/Rectangle 42213 (1).png";
import img3 from "../../Images/Rectangle 42213 (2).png";
import img4 from "../../Images/Rectangle 42213 (3).png";
import img5 from "../../Images/Rectangle 42213 (4).png";
import logo from "../../Images/Group 1171276875.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import ReelsPlayer from "./ReelsPlayer/ReelsPlayer";
  import { useNavigate } from "react-router-dom";
// import ReelsPlayer from "./ReelsPlayer"; // ReelsPlayer import করুন

const UpcomingProjects = () => {
  const [reels, setReels] = useState([]);
  const [selectedReel, setSelectedReel] = useState(null);
  const [isReelsPlayerOpen, setIsReelsPlayerOpen] = useState(false);


const navigate = useNavigate();

  const fetchReels = async () => {
    try {
      const res = await HomeService.getReels();
      console.log("reels", res);
      if (res?.status) {
        setReels(res?.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  // Reel select করার function
  const handleReelClick = (reel) => {
    setSelectedReel(reel);
    setIsReelsPlayerOpen(true);
  };

  // ReelsPlayer বন্ধ করার function
  const handleCloseReelsPlayer = () => {
    setIsReelsPlayerOpen(false);
    setSelectedReel(null);
  };

  useEffect(() => {
    fetchReels();
  }, []);

useEffect(() => {
  const handleEsc = (e) => {
    if (e.key === "Escape" && isReelsPlayerOpen) {
      handleCloseReelsPlayer();
    }
  };

  document.addEventListener("keydown", handleEsc);

  return () => {
    document.removeEventListener("keydown", handleEsc);
  };
}, [isReelsPlayerOpen]);

  const settings = {
    //  className: "center",
    centerMode: false,
    infinite: true,
    //  centerPadding: "340px",
    slidesToShow: 4,
    speed: 500,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          centerPadding: "250px",
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "0px",
          centerMode: false,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "0px",
          centerMode: false,
        },
      },
    ],
  };
  
  
  return (
    <>
      <div className="upcoming_project_wrapper">
        <div className="">
          <h1 className="upcoming_projects_head">Our Upcoming Projects</h1>
          <Slider {...settings}>
            {reels.map((reel, i) => (
              <div
                key={reel._id}
                className="projects_div_wrapper156"
                onClick={() => handleReelClick(reel)}
                style={{ cursor: "pointer" }}
              >
                <img
                  className="project_img456"
                  src={reel?.thumbnail}
                  alt={`Project ${i + 1}`}
                  style={{ cursor: "pointer" }}
                />
                <img src={logo} className="circle_img_wrapper" alt="Logo" />
                {/* <div className="project_details_div_wrapper5666">
                  <p>Kolkata</p>
                  <small>Real Estate</small>
                </div> */}

                {/* Play button overlay */}
                {/* <div className="play-button-overlay">
                  <div className="play-icon">
                    <i className="fas fa-play"></i>
                  </div>
                </div> */}
                <div className="play_btn_nb">
                  <i class="fa-solid fa-play"></i>

                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* Reels Player Popup Modal */}
      {isReelsPlayerOpen && selectedReel && (
        <div className="reels-modal-overlay" onClick={handleCloseReelsPlayer}>
          <div
            className="reels-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-reels-btn"
              onClick={handleCloseReelsPlayer}
            >
              <i className="fas fa-times"></i>
            </button>
            <ReelsPlayer
              videoUrl={selectedReel?.video}
              autoPlay={true}
              muted={false}
              controls={true}
              loop={true}
            />
          </div>
        </div>
      )}

      {/* CSS styles inline (আপনি আলাদা CSS file-ও use করতে পারেন) */}
      <style jsx>{`
        .reels-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .reels-modal-content {
          position: relative;
          max-width: 400px;
          width: 100%;
           height:90%;
          background: #000;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
        }

        .close-reels-btn {
          position: absolute;
          top: 15px;
          right: 15px;
          background: rgba(0, 0, 0, 0.7);
          border: none;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          transition: all 0.3s ease;
        }

        .close-reels-btn:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }

        .play-button-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
           background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 12px;
        }

        .projects_div_wrapper156:hover .play-button-overlay {
          opacity: 1;
        }

        .play-icon {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 20px;
          transition: transform 0.3s ease;
        }

        .projects_div_wrapper156:hover .play-icon {
          transform: scale(1.1);
        }

        /* Responsive Design for Modal */
      
        @media (max-width: 768px) {
          .reels-modal-content {
            max-width: 350px;
          }
        }

        @media (max-width: 480px) {
          .reels-modal-content {
            max-width: 300px;
          }

          .reels-modal-overlay {
            padding: 10px;
          }
        }

        /* Ensure the project items are properly styled */
        .projects_div_wrapper156 {
          position: relative;
          transition: transform 0.3s ease;
        }

        .projects_div_wrapper156:hover {
          transform: scale(1.05);
        }
      `}</style>
    </>
  );
};

export default UpcomingProjects;
